import React, { useContext, useEffect, useState } from "react";
import { Box, FormControl, MenuItem, Select, SelectProps } from "@mui/material";

import "./style.css";
import useTranslation from "../../hooks/translations";
import { getContrastTextColor } from "../../utils/colorManager";
import { GlobalContext } from "../../context/GlobalContext";
import palette from "../../styles/palette";

interface LanguageToggleProps extends Omit<SelectProps, "defaultValue"> {
  language?: string;
  changeLanguage: (language: string) => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({
  language,
  changeLanguage,
  ...props
}) => {
  const { t } = useTranslation();
  const { theme } = useContext(GlobalContext);
  const [headerColor, setHeaderColor] = useState("");

  const bootstrapInputSx = {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor:
        getContrastTextColor(headerColor) === "light"
          ? palette.text.light
          : palette.black,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor:
        getContrastTextColor(headerColor) === "light" ? "white" : "black",
    },
    "& .MuiSelect-icon": {
      color:
        getContrastTextColor(headerColor) === "light"
          ? palette.text.light
          : palette.black,
    },
  };

  useEffect(() => {
    if (theme?.headerColor) setHeaderColor(theme?.headerColor);
  }, [theme?.headerColor]);

  return (
    <Box className={"languageBox"}>
      <FormControl className={"languageFormControl"}>
        <Select
          value={language}
          onChange={(e) => changeLanguage(e.target.value as string)}
          className={"languageSelect2"}
          {...props}
          sx={{
            ...bootstrapInputSx,
            color:
              getContrastTextColor(headerColor) === "light"
                ? palette.text.light
                : palette.black,
          }}
        >
          <MenuItem value="en">{t("english")}</MenuItem>
          <MenuItem value="fr">{t("french")}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LanguageToggle;
